import React from "react";
import { useTheme } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Images } from "../../../utils/Images";

const BannerSection = ({ title = "", subtitle = "", backgroundImage = null }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isAbove1200 = useMediaQuery("(min-width: 1200px)");
  
  // Use CMS image if provided and valid, otherwise use default sub-banner pattern
  const backgroundImageUrl =
    backgroundImage && backgroundImage.trim() !== ""
      ? backgroundImage
      : Images.bannerPattern || "";

  const hasCustomImage =
    backgroundImage &&
    backgroundImage.trim() !== "" &&
    backgroundImage !== Images.bannerPattern;
  
  return (
    <div
      style={{
        width: "94.44%",
        maxWidth: "1440px",
        minHeight: isMobile ? "110px" : isAbove1200 ? "167px" : "167px",
        borderRadius: isMobile ? "12px" : "20px",
        background: backgroundImageUrl
          ? `url(${backgroundImageUrl}) no-repeat center center / cover`
          : `url(${Images.bannerPattern || ""}) no-repeat center center / cover`,
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Banner Pattern with reduced opacity */}
      {/* <img
        src={Images.bannerPattern}
        alt="Banner Pattern"
        style={{
          position: "absolute",
          top: "0px",
          right: "0px",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: 0.4, // Reduced opacity to show background color
          zIndex: 1,
        }}
      />
       */}
      {/* Decorative Images.heart - Top Right - Only show if no custom image */}
      {!hasCustomImage && (
        <img
          src={Images.heart}
          alt="Heart"
          style={{
            position: "absolute",
            top: isMobile ? "15px" : isAbove1200 ? "50%" : "50%",
            right: isMobile ? "15px" : isAbove1200 ? "350px" : "160px",
            width: isMobile ? "13px" : isAbove1200 ? "22px" : "23px",
            height: "23px",
            zIndex: 2,
            transform: "translateY(-50%)",
          }}
        />
      )}

      {/* Content Container */}
      <div style={{ position: "relative", zIndex: 2 }}>
        {/* Title Box */}
        <Typography
          sx={{
            fontFamily: "Red Hat Display, sans-serif",
            fontWeight: 700,
            fontSize: isMobile ? "16px" : "36px",
            lineHeight: "100%",
            letterSpacing: "-0.01em",
            color: "#1D1D1B",
            textAlign: "center",
            marginBottom: isMobile ? "10px" : isAbove1200 ? "12px" : "12px",
            verticalAlign: "middle",
          }}
        >
          {title}
        </Typography>

        {/* Subtitle Box */}
        <Typography
          sx={{
            fontFamily: "Red Hat Display, sans-serif",
            fontWeight: 500,
            fontSize: isMobile ? "12px" : "16px",
            lineHeight: isMobile ? "18px" : "24px",
            letterSpacing: "-0.01em",
            color: "#4A4A49",
            textAlign: "center",
            verticalAlign: "middle",
            maxWidth: isMobile ? "120px" : "100%",
            whiteSpace: isMobile ? "pre-line" : "normal",
            margin: "0 auto",
          }}
        >
          {subtitle}
        </Typography>
      </div>

      {/* Decorative red outline hands - bottom left - Only show if no custom image */}
      {!hasCustomImage && (
        <>
          <img
            src={Images.redOutlineHands}
            alt="Red Outline Hands"
            style={{
              position: "absolute",
              bottom: isMobile ? "-25px" : isAbove1200 ? "-7px" : "-7px",
              left: isMobile ? "15px" : isAbove1200 ? "100px" : "60px",
              width: isMobile ? "41px" : isAbove1200 ? "100px" : "100px",
              height: isMobile ? "100px" : isAbove1200 ? "123px" : "123px",
              zIndex: 2,
              transform:"rotateY(180deg)",
            }}
          />

          <img
            src={Images.redOutlineHands}
            alt="Red Outline Hands"
            style={{
              position: "absolute",
              bottom: isMobile ? "-25px" : isAbove1200 ? "-7px" : "-7px",
              right: isMobile ? "15px" : isAbove1200 ? "45px" : "40px",
              width: isMobile ? "41px" : isAbove1200 ? "100px" : "100px",
              height: isMobile ? "100px" : isAbove1200 ? "123px" : "123px",
              zIndex: 2,
            }}
          />

          <img
            src={Images.greenHand}
            alt="Green Hand"
            style={{
              position: "absolute",
              top: isMobile ? "15px" : isAbove1200 ? "90px" : "60px",
              left: isMobile ? "15px" : isAbove1200 ? "30px" : "30px",
              width: isMobile ? "20px" : isAbove1200 ? "28px" : "28px",
              height: isMobile ? "20px" : isAbove1200 ? "30px" : "30px",
              zIndex: 2,
              transform: "scaleX(-1) translateY(-50%)",
            }}
          />
        </>
      )}
    </div>
  );
};

export default BannerSection;